import { useState, useEffect } from "react";
import { Form, useNavigate } from "react-router-dom";
import { updateFiling } from "../../api/filings/filingAPI";
import NotificationAlert from "../ui/alerts/notifications/NotificationAlert";
import { Handler401 } from "../../api/utils/responseActions";
import FormSectionWrapper from "../ui/account/FormSectionWrapper";

function TaxTypeForm({ services, allowServices, filingUuid, onSubmit }) {
  const navigate = useNavigate();
  const hasPersonalNewFiling = allowServices.some(
    (service) => service.type === "PTF"
  );
  const hasBusinessNewFiling = allowServices.some(
    (service) => service.type === "BTF"
  );
  const hasNewPlanning = allowServices.some(
    (service) => service.type === "TPC"
  );
  const serviceArray = Array.isArray(services)
    ? services
    : services?.services || [];
  // const [selectedOption, changeSelectedOption] = useState(props.filingType);
  const [selectedOptions, setSelectedOptions] = useState({
    personalTax: serviceArray.includes("PTF"),
    businessTax: serviceArray.includes("BTF"),
    planningTax: serviceArray.includes("TPC"),
  });

  // Update selectedOptions when services prop changes
  useEffect(() => {
    setSelectedOptions({
      personalTax: serviceArray.includes("PTF"),
      businessTax: serviceArray.includes("BTF"),
      planningTax: serviceArray.includes("TPC"),
    });
  }, [serviceArray]);

  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    let taxServices = [];
    if (selectedOptions.personalTax) {
      taxServices.push("PTF");
    }
    if (selectedOptions.businessTax) {
      taxServices.push("BTF");
    }
    if (selectedOptions.planningTax) {
      taxServices.push("TPC");
    }

    const data = {
      tax_service: { services: taxServices },
    };

    const apiUrl = "tax/filing";

    try {
      const response = await updateFiling(apiUrl, data, filingUuid);

      if (response.ok) {
        const responseData = await response.json();
        onSubmit(responseData.tax_service);
      } else {
        // Handle errors
        if (response.status === 401) {
          Handler401(navigate);
          return;
        }

        // Try to get the actual error message from the response
        try {
          const errorData = await response.json();
          setError(
            errorData.message || "You must select at least one tax service."
          );
        } catch (parseError) {
          setError("You must select at least one tax service.");
        }
      }
    } catch (error) {
      setError(error);
    }
  };

  const handlerOptionChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  return (
    <div className="columns">
      {error && (
        <NotificationAlert
          alertType="error"
          alertTitle="Invalid Selection"
          alertDescription={error}
        />
      )}
      <Form method="post" onSubmit={handleSubmit}>
        <FormSectionWrapper
          title="Filing Type"
          infoTooltip="Select whether you’re filing personal taxes, business taxes, or both."
        >
          <div className="form-field">
            <div className="checkbox-container">
              {hasPersonalNewFiling && (
                <div className="checkbox-item">
                  <div className="checkbox-representation">
                    <input
                      type="checkbox"
                      name="personalTax"
                      value="PersonalTax"
                      id="checkbox1"
                      checked={selectedOptions.personalTax}
                      onChange={handlerOptionChange}
                    />
                    <label htmlFor="checkbox1">Personal filing</label>
                  </div>
                </div>
              )}

              {hasBusinessNewFiling && (
                <div className="checkbox-item">
                  <div className="checkbox-representation">
                    <input
                      type="checkbox"
                      name="businessTax"
                      value="BusinessTax"
                      id="checkbox2"
                      checked={selectedOptions.businessTax}
                      onChange={handlerOptionChange}
                    />
                    <label htmlFor="checkbox2">Business or trust filing</label>
                  </div>
                </div>
              )}

              {hasNewPlanning && (
                <div className="checkbox-item">
                  <div className="checkbox-representation">
                    <input
                      type="checkbox"
                      name="planningTax"
                      value="TaxPlanning"
                      id="checkbox3"
                      checked={selectedOptions.planningTax}
                      onChange={handlerOptionChange}
                    />
                    <label htmlFor="checkbox3">Tax planning/consulting</label>
                  </div>
                </div>
              )}
            </div>
          </div>
        </FormSectionWrapper>
        <div className="prevNext">
          <button className="cta-button primary">
            <b>Next</b>
          </button>
        </div>
      </Form>
    </div>
  );
}

export default TaxTypeForm;
